import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  svgPath: React.ReactNode;
  title?: string;
}

const Icon: React.FC<IconProps> = ({ svgPath, title, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      {...props}
    >
      {title && <title>{title}</title>}
      {svgPath}
    </svg>
  );
};

export default Icon;
